import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');

// URL //
const eachUrl = 'low_side_effect/getEach?';
const allUrl = 'low_side_effect/get?';
const storeUrl = 'low_side_effect/store';
const updateUrl = 'low_side_effect/update?';
const deleteUrl = 'low_side_effect/delete?';


const state = {
  sideEffects: [],
  sideEffect: {},
};
const getters = {};
const mutations = {
  SET_SIDE_EFFECTS(state, payload) {
    state.sideEffects = payload.data.data;
  },
  SET_SIDE_EFFECT(state, payload) {
    state.sideEffect = payload.data.data;
  },
  ADD_SIDE_EFFECT(state, payload) {
    state.sideEffects.push(payload.data.data);
  },
  REMOVE_SIDE_EFFECT(state, payload) {
    const sideEffects = state.sideEffects.filter(
      (item) => item.id != payload.id
    );
    state.sideEffects = [...sideEffects];
  },
};

const actions = {
  async get({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_SIDE_EFFECTS", response);
  },
  
  async getEach({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_SIDE_EFFECT", response);
  },
  async create({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_SIDE_EFFECT", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async update(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async delete({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_SIDE_EFFECT", payload);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
